
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/var/canvas/ui/features/assignment_edit/jst/_submission_types_form.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/assignment-edit/jst/EditView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div class=\"alert alert-info\">\n      <i class=\"icon-warning\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "some_settings_have_been_administratively_locked_9e3ee880", "Some settings have been administratively locked.", options) : helperMissing.call(depth0, "t", "some_settings_have_been_administratively_locked_9e3ee880", "Some settings have been administratively locked.", options)))
    + "\n    </div>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div class=\"alert alert-info\">\n      <i class=\"icon-warning\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "some_settings_have_been_disabled_because_the_assig_6b6cc3b4", "Some settings have been disabled because the assignment is in a closed grading period.", options) : helperMissing.call(depth0, "t", "some_settings_have_been_disabled_because_the_assig_6b6cc3b4", "Some settings have been disabled because the assignment is in a closed grading period.", options)))
    + "\n    </div>\n  ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <h1 id=\"assignment_name\" class=\"title\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h1>\n      <input type=\"hidden\" name=\"name\" value=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></input>\n    ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <div>\n        <label for=\"assignment_name\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignment_name_b2d87383", "Assignment Name", options) : helperMissing.call(depth0, "t", "assignment_name_b2d87383", "Assignment Name", options)))
    + "\n          <span id=\"assignment_name_asterisk\" aria-hidden=\"true\">*</span>\n        </label>\n        <input id=\"assignment_name\"\n          name=\"name\"\n          placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignments.edit_view.assignment_name", "Assignment Name", options) : helperMissing.call(depth0, "t", "assignments.edit_view.assignment_name", "Assignment Name", options)))
    + "\"\n          value=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n          type=\"text\"\n          required\n          class=\"input-block-level\"\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inClosedGradingPeriod), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          "
    + escapeExpression((helper = helpers.disabledIfIncludes || (depth0 && depth0.disabledIfIncludes),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.frozenAttributes), "title", options) : helperMissing.call(depth0, "disabledIfIncludes", (depth0 && depth0.frozenAttributes), "title", options)))
    + "\n          autofocus></input>\n          <div id=\"name_errors\" aria-live=\"assertive\"></div>\n      </div>\n    ";
  return buffer;
  }
function program8(depth0,data) {
  
  
  return "\n            readonly\n          ";
  }

function program10(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"control-group\">\n      ";
  stack1 = (helper = helpers.ifIncludes || (depth0 && depth0.ifIncludes),options={hash:{},inverse:self.program(13, program13, data),fn:self.program(11, program11, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.frozenAttributes), "description", options) : helperMissing.call(depth0, "ifIncludes", (depth0 && depth0.frozenAttributes), "description", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  ";
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <div class=\"frozen-description user_content\">\n          "
    + escapeExpression((helper = helpers.convertApiUserContent || (depth0 && depth0.convertApiUserContent),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.description), options) : helperMissing.call(depth0, "convertApiUserContent", (depth0 && depth0.description), options)))
    + "\n        </div>\n      ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.content), {hash:{},inverse:self.program(16, program16, data),fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  return buffer;
  }
function program14(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <div id=\"assignment_description\" class=\"assignment_description\">\n            "
    + escapeExpression((helper = helpers.convertApiUserContent || (depth0 && depth0.convertApiUserContent),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.description), options) : helperMissing.call(depth0, "convertApiUserContent", (depth0 && depth0.description), options)))
    + "\n          </div>\n        ";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <textarea id=\"assignment_description\"\n            name=\"description\"\n            aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignments.edit_view.description", "Description", options) : helperMissing.call(depth0, "t", "assignments.edit_view.description", "Description", options)))
    + "\"\n            "
    + escapeExpression((helper = helpers.disabledIfIncludes || (depth0 && depth0.disabledIfIncludes),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.frozenAttributes), "description", options) : helperMissing.call(depth0, "disabledIfIncludes", (depth0 && depth0.frozenAttributes), "description", options)))
    + ">\n            "
    + escapeExpression((helper = helpers.convertApiUserContent || (depth0 && depth0.convertApiUserContent),options={hash:{
    'forEditing': (1)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.description), options) : helperMissing.call(depth0, "convertApiUserContent", (depth0 && depth0.description), options)))
    + "\n          </textarea>\n        ";
  return buffer;
  }

function program18(depth0,data) {
  
  
  return "\n    <div id=\"quiz_type_selector\" class=\"control-group\"></div>\n  ";
  }

function program20(depth0,data) {
  
  
  return "\n          <div id=\"points_tooltip\"></div>\n        ";
  }

function program22(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <div aria-live=\"polite\" role=\"alert\">\n          <div id=point_change_warning class=\"alert\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "if_you_change_an_assignment_s_points_possible_you__dba531cb", "If you change an assignment's points possible, you must regrade any submissions.", options) : helperMissing.call(depth0, "t", "if_you_change_an_assignment_s_points_possible_you__dba531cb", "If you change an assignment's points possible, you must regrade any submissions.", options)))
    + "\n           </div>\n        </div>\n      ";
  return buffer;
  }

function program24(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div id=\"anonymous_submission_selector\" class=\"control-group\" style=\""
    + escapeExpression((helper = helpers.hiddenUnless || (depth0 && depth0.hiddenUnless),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.showAnonymousSubmissionSelector), options) : helperMissing.call(depth0, "hiddenUnless", (depth0 && depth0.showAnonymousSubmissionSelector), options)))
    + "\"></div>\n  ";
  return buffer;
  }

function program26(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_omit_from_final_grade"),
    'name': ("omit_from_final_grade"),
    'readonly': ("readonly"),
    'aria-readonly': ("true")
  },data:data},helper ? helper.call(depth0, "omitFromFinalGrade", options) : helperMissing.call(depth0, "checkbox", "omitFromFinalGrade", options)))
    + "\n        ";
  return buffer;
  }

function program28(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_omit_from_final_grade"),
    'name': ("omit_from_final_grade")
  },data:data},helper ? helper.call(depth0, "omitFromFinalGrade", options) : helperMissing.call(depth0, "checkbox", "omitFromFinalGrade", options)))
    + "\n        ";
  return buffer;
  }

function program30(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <div class=\"control-group\">\n        <div class=\"form-column-left no-group\"></div>\n        <div id=\"suppress_from_gradebook\" class=\"form-column-right\" style=\"margin-top: 14px;\">\n          <label class=\"checkbox\">\n\n              "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_suppress_from_gradebook"),
    'name': ("suppress_from_gradebook")
  },data:data},helper ? helper.call(depth0, "suppressAssignment", options) : helperMissing.call(depth0, "checkbox", "suppressAssignment", options)))
    + "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "hide_from_gradebook_view_and_student_grades_view_22a5a606", "Hide from gradebook view and student grades view", options) : helperMissing.call(depth0, "t", "hide_from_gradebook_view_and_student_grades_view_22a5a606", "Hide from gradebook view and student grades view", options)))
    + "\n          </label>\n        </div>\n      </div>\n    ";
  return buffer;
  }

function program32(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isQuizLTIAssignment), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program33(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <div id=\"assignment_hide_in_gradebook_option\">\n            <div id=\"hide-in-gradebook-set\">\n              <div class=\"form-column-left\"></div>\n              <div id=\"hide_in_gradebook\" class=\"form-column-right\">\n                <label class=\"checkbox\">\n                  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inClosedGradingPeriod), {hash:{},inverse:self.program(36, program36, data),fn:self.program(34, program34, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "do_not_display_in_gradebook_or_the_student_s_grade_3de05e1c", "Do not display in gradebook or the student's grade page", options) : helperMissing.call(depth0, "t", "do_not_display_in_gradebook_or_the_student_s_grade_3de05e1c", "Do not display in gradebook or the student's grade page", options)))
    + "\n                </label>\n              </div>\n            </div>\n          </div>\n      ";
  return buffer;
  }
function program34(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                    "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_hide_in_gradebook"),
    'name': ("hide_in_gradebook"),
    'readonly': ("readonly"),
    'aria-readonly': ("true")
  },data:data},helper ? helper.call(depth0, "hideInGradebook", options) : helperMissing.call(depth0, "checkbox", "hideInGradebook", options)))
    + "\n                  ";
  return buffer;
  }

function program36(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                    "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_hide_in_gradebook"),
    'name': ("hide_in_gradebook")
  },data:data},helper ? helper.call(depth0, "hideInGradebook", options) : helperMissing.call(depth0, "checkbox", "hideInGradebook", options)))
    + "\n                  ";
  return buffer;
  }

function program38(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <div id=\"allowed_attempts_fields\" class=\"control-group\">\n        <div class=\"form-column-left\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignments.edit_view.submission_attempts", "Submission Attempts", options) : helperMissing.call(depth0, "t", "assignments.edit_view.submission_attempts", "Submission Attempts", options)))
    + "\n        </div>\n        <div class=\"form-column-right\">\n          <div class=\"border border-trbl border-round\">\n            <div id=\"allowed-attempts-target\"></div>\n          </div>\n        </div>\n      </div>\n    ";
  return buffer;
  }

function program40(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <div id=\"group_category_selector\"\n        class=\"control-group\"\n        style=\""
    + escapeExpression((helper = helpers.hiddenIf || (depth0 && depth0.hiddenIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.isExternalTool), options) : helperMissing.call(depth0, "hiddenIf", (depth0 && depth0.isExternalTool), options)))
    + "\">\n      </div>\n    ";
  return buffer;
  }

function program42(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <div id=\"assignment_peer_reviews_fields\"\n        class=\"control-group\"\n        style=\""
    + escapeExpression((helper = helpers.hiddenIf || (depth0 && depth0.hiddenIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.isExternalTool), options) : helperMissing.call(depth0, "hiddenIf", (depth0 && depth0.isExternalTool), options)))
    + "\">\n      </div>\n    ";
  return buffer;
  }

function program44(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <div>\n        <div class=\"form-column-left\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'postToSISName': ((depth0 && depth0.postToSISName)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "sync_to_posttosisname_dffd5c9", "Sync to %{postToSISName}", options) : helperMissing.call(depth0, "t", "sync_to_posttosisname_dffd5c9", "Sync to %{postToSISName}", options)))
    + "</div>\n          <div class=\"form-column-right\" style=\"margin-top: 14px;\">\n            <label class=\"checkbox\">\n              "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_post_to_sis"),
    'name': ("post_to_sis")
  },data:data},helper ? helper.call(depth0, "postToSIS", options) : helperMissing.call(depth0, "checkbox", "postToSIS", options)))
    + "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "include_this_assignment_s_grades_when_syncing_to_y_55bfa487", "Include this assignment's grades when syncing to your school's Student Information System", options) : helperMissing.call(depth0, "t", "include_this_assignment_s_grades_when_syncing_to_y_55bfa487", "Include this assignment's grades when syncing to your school's Student Information System", options)))
    + "\n            </label>\n        </div>\n      </div>\n    ";
  return buffer;
  }

function program46(depth0,data) {
  
  
  return "\n      <span data-component=\"ModeratedGradingFormFieldGroup\"></span>\n    ";
  }

function program48(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <div>\n        <div class=\"form-column-left\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "anonymous_grading_ccb5045c", "Anonymous Grading", options) : helperMissing.call(depth0, "t", "anonymous_grading_ccb5045c", "Anonymous Grading", options)))
    + "</div>\n        <div id=\"enable-anonymous-grading\" class=\"form-column-right\">\n          <div class=\"border border-trbl border-round\">\n            <label class=\"checkbox\">\n              "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'class': ("GradeAnonymously__Checkbox"),
    'id': ("assignment_anonymous_grading"),
    'name': ("anonymous_grading")
  },data:data},helper ? helper.call(depth0, "anonymousGrading", options) : helperMissing.call(depth0, "checkbox", "anonymousGrading", options)))
    + "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "graders_cannot_view_student_names_2e8d3ff9", "Graders cannot view student names", options) : helperMissing.call(depth0, "t", "graders_cannot_view_student_names_2e8d3ff9", "Graders cannot view student names", options)))
    + "\n            </label>\n\n            <label class=\"checkbox\" for=\"assignment_graders_anonymous_to_graders\" style=\""
    + escapeExpression((helper = helpers.hiddenUnless || (depth0 && depth0.hiddenUnless),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.showGradersAnonymousToGradersCheckbox), options) : helperMissing.call(depth0, "hiddenUnless", (depth0 && depth0.showGradersAnonymousToGradersCheckbox), options)))
    + "\">\n              "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_graders_anonymous_to_graders"),
    'name': ("graders_anonymous_to_graders")
  },data:data},helper ? helper.call(depth0, "gradersAnonymousToGraders", options) : helperMissing.call(depth0, "checkbox", "gradersAnonymousToGraders", options)))
    + "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "graders_cannot_view_each_other_s_names_b1fa7899", "Graders cannot view each other's names", options) : helperMissing.call(depth0, "t", "graders_cannot_view_each_other_s_names_b1fa7899", "Graders cannot view each other's names", options)))
    + "\n            </label>\n          </div>\n        </div>\n      </div>\n    ";
  return buffer;
  }

function program50(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <div>\n        <div class=\"form-column-left\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "anonymous_instructor_annotations_2b6c822", "Anonymous Instructor Annotations", options) : helperMissing.call(depth0, "t", "anonymous_instructor_annotations_2b6c822", "Anonymous Instructor Annotations", options)))
    + "</div>\n        <div class=\"form-column-right\" style=\"margin-top: 14px;\">\n          <label class=\"checkbox\">\n            "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_anonymous_instructor_annotations"),
    'name': ("anonymous_instructor_annotations")
  },data:data},helper ? helper.call(depth0, "anonymousInstructorAnnotations", options) : helperMissing.call(depth0, "checkbox", "anonymousInstructorAnnotations", options)))
    + "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "anonymize_all_annotations_made_by_instructors_on_s_5540bc09", "Anonymize all annotations made by instructors on submissions for this assignment in DocViewer", options) : helperMissing.call(depth0, "t", "anonymize_all_annotations_made_by_instructors_on_s_5540bc09", "Anonymize all annotations made by instructors on submissions for this assignment in DocViewer", options)))
    + "\n          </label>\n        </div>\n      </div>\n    ";
  return buffer;
  }

function program52(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div class=\"form-column-left\"></div>\n    <div class=\"form-column-right\">\n      <div>\n        <label class=\"checkbox\" for=\"assignment_freeze_on_copy\">\n          "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_freeze_on_copy"),
    'name': ("freeze_on_copy")
  },data:data},helper ? helper.call(depth0, "freezeOnCopy", options) : helperMissing.call(depth0, "checkbox", "freezeOnCopy", options)))
    + "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignments.edit_view.freeze_properties", "Lock assignment properties when copied", options) : helperMissing.call(depth0, "t", "assignments.edit_view.freeze_properties", "Lock assignment properties when copied", options)))
    + "\n        </label>\n      </div>\n    </div>\n  ";
  return buffer;
  }

function program54(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div class=\"form-column-left\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "mastery_paths_cc4096c2", "Mastery Paths", options) : helperMissing.call(depth0, "t", "mastery_paths_cc4096c2", "Mastery Paths", options)))
    + "\n    </div>\n    <div class=\"overrides-column-right js-assignment-overrides-mastery-path overrideFormFlex\">\n    </div>\n  ";
  return buffer;
  }

function program56(depth0,data) {
  
  
  return "\n<div id=\"mastery-paths-editor\" style=\"display: none\">\n  <div id=\"conditional_release_target\"></div>\n</div>\n";
  }

function program58(depth0,data) {
  
  
  return "\n  <input type=\"hidden\" name=\"quiz_lti\" value=\"1\"></input>\n";
  }

function program60(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.is_horizon_course), {hash:{},inverse:self.noop,fn:self.program(61, program61, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program61(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <button type=\"button\" class=\"btn btn-default save_and_publish\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignments.edit_view.buttons.save_and_publish", "Save & Publish", options) : helperMissing.call(depth0, "t", "assignments.edit_view.buttons.save_and_publish", "Save & Publish", options)))
    + "\n        </button>\n      ";
  return buffer;
  }

function program63(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <button type=\"button\" class=\"btn btn-default save_button\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignments.edit_view.buttons.save", "Save", options) : helperMissing.call(depth0, "t", "assignments.edit_view.buttons.save", "Save", options)))
    + "\n      </button>\n      <button type=\"submit\" class=\"btn btn-primary build_button\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignments.edit_view.buttons.build", "Build", options) : helperMissing.call(depth0, "t", "assignments.edit_view.buttons.build", "Build", options)))
    + "\n      </button>\n    ";
  return buffer;
  }

function program65(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <button type=\"submit\" class=\"btn btn-primary\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignments.edit_view.buttons.save", "Save", options) : helperMissing.call(depth0, "t", "assignments.edit_view.buttons.save", "Save", options)))
    + "\n      </button>\n    ";
  return buffer;
  }

  buffer += "<div id=\"edit_assignment_wrapper\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.frozen), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inClosedGradingPeriod), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n\n  <div class=\"control-group\">\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.content), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isQuizLTIAssignment), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isQuizLTIAssignment), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <div class=\"control-group\">\n\n    <div class=\"form-column-left no-group\">\n      <label for=\"assignment_points_possible\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignments.edit_view.points_possible", "Points", options) : helperMissing.call(depth0, "t", "assignments.edit_view.points_possible", "Points", options)))
    + "\n      </label>\n    </div>\n\n    <div class=\"form-column-right\" style=\"width: unset; margin-bottom: 12px;\">\n      <div style=\"display:inline-flex;align-items:center;gap:8px;\">\n        <input id=\"assignment_points_possible\"\n          name=\"points_possible\"\n          style=\"width: 374px; margin-bottom: unset;\"\n          value=\""
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.pointsPossible), options) : helperMissing.call(depth0, "n", (depth0 && depth0.pointsPossible), options)))
    + "\"\n          type=\"text\"\n          ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.inClosedGradingPeriod), ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.points), (depth0 && depth0.cannotEditGrades), options) : helperMissing.call(depth0, "ifAny", (depth0 && depth0.inClosedGradingPeriod), ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.points), (depth0 && depth0.cannotEditGrades), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          "
    + escapeExpression((helper = helpers.disabledIfIncludes || (depth0 && depth0.disabledIfIncludes),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.frozenAttributes), "points_possible", options) : helperMissing.call(depth0, "disabledIfIncludes", (depth0 && depth0.frozenAttributes), "points_possible", options)))
    + "\n        ></input>\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isQuizLTIAssignment), {hash:{},inverse:self.noop,fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n      <div id=\"points_possible_errors\"></div>\n      ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.points), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n\n  </div>\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isQuizLTIAssignment), {hash:{},inverse:self.noop,fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <div id=\"assignment_group_selector\" class=\"control-group\"></div>\n\n  <div id=\"grading_type_selector\"></div>\n\n  <div id=\"graded_assignment_fields\"\n    style=\""
    + escapeExpression((helper = helpers.hiddenIf || (depth0 && depth0.hiddenIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.isNotGraded), options) : helperMissing.call(depth0, "hiddenIf", (depth0 && depth0.isNotGraded), options)))
    + "\">\n\n    \n    <div class=\"form-column-left\"></div>\n    <div id=\"omit-from-final-grade\" class=\"form-column-right\" style=\"margin-top: 14px;\">\n      <label class=\"checkbox\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inClosedGradingPeriod), {hash:{},inverse:self.program(28, program28, data),fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "do_not_count_this_assignment_towards_the_final_gra_4dd92e00", "Do not count this assignment towards the final grade", options) : helperMissing.call(depth0, "t", "do_not_count_this_assignment_towards_the_final_gra_4dd92e00", "Do not count this assignment towards the final grade", options)))
    + "\n      </label>\n    </div>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.suppressAssignmentAllowed), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hideZeroPointQuizzesOptionEnabled), {hash:{},inverse:self.noop,fn:self.program(32, program32, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = self.invokePartial(partials['ui/features/assignment_edit/jst/_submission_types_form.handlebars'], 'ui/features/assignment_edit/jst/_submission_types_form.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assignment_attempts), {hash:{},inverse:self.noop,fn:self.program(38, program38, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    <div id=\"similarity_detection_tools\">\n    </div>\n\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isLargeRoster), {hash:{},inverse:self.noop,fn:self.program(40, program40, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isLargeRoster), {hash:{},inverse:self.noop,fn:self.program(42, program42, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.postToSISEnabled), {hash:{},inverse:self.noop,fn:self.program(44, program44, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isQuizLTIAssignment), {hash:{},inverse:self.noop,fn:self.program(46, program46, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.anonymousGradingEnabled), {hash:{},inverse:self.noop,fn:self.program(48, program48, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.anonymousInstructorAnnotationsEnabled), {hash:{},inverse:self.noop,fn:self.program(50, program50, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canFreeze), {hash:{},inverse:self.noop,fn:self.program(52, program52, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <fieldset id=\"overrides-wrapper\">\n    <div class=\"form-column-left\">\n      <legend id=\"assignment_overrides\">\n        <label for=\"assignment_overrides\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assign_access_ecd4227b", "Assign Access", options) : helperMissing.call(depth0, "t", "assign_access_ecd4227b", "Assign Access", options)))
    + "\n        </label>\n      </legend>\n    </div>\n    <div class=\"overrides-column-right js-assignment-overrides overrideFormFlex\">\n    </div>\n  </fieldset>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.coursePaceWithMasteryPath), {hash:{},inverse:self.noop,fn:self.program(54, program54, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n<div id=\"asset_processors_container\" style=\"margin-bottom: 14px\"></div>\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.conditionalReleaseServiceEnabled), {hash:{},inverse:self.noop,fn:self.program(56, program56, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isQuizLTIAssignment), {hash:{},inverse:self.noop,fn:self.program(58, program58, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n<input type='hidden' id=\"secure_params\" name=\"secure_params\" value=\"";
  if (helper = helpers.secureParams) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.secureParams); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></input>\n\n<div id=\"assignment_external_tools\"></div>\n\n<div class=\"form-actions\">\n  <div class=\"pull-left\">\n    <label class=\"checkbox\" style=\"text-align:left;\" for=\"assignment_notify_of_update\">\n      "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_notify_of_update"),
    'name': ("notify_of_update")
  },data:data},helper ? helper.call(depth0, "notifyOfUpdate", options) : helperMissing.call(depth0, "checkbox", "notifyOfUpdate", options)))
    + "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "assignments.edit_view.notify_content_change", "Notify users that this content has changed", options) : helperMissing.call(depth0, "t", "assignments.edit_view.notify_content_change", "Notify users that this content has changed", options)))
    + "\n    </label>\n  </div>\n  <div class=\"assignment__action-buttons\">\n    <button type=\"button\" class=\"btn cancel_button\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("buttons"),
    'i18n_used_in': ("assignments.edit_view")
  },data:data},helper ? helper.call(depth0, "buttons.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "buttons.cancel", "Cancel", options)))
    + "\n    </button>\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(60, program60, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showBuildButton), {hash:{},inverse:self.program(65, program65, data),fn:self.program(63, program63, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  